export default __webpack_public_path__ + "static/media/close-rond.a0c184f4.svg";